import { useState } from "react"
import { OrganizationTab } from "./organization-tab.tsx"

type Tab = "organization" | "departments" | "configurations"

export function SettingsPage() {
  const [activeTab, setActiveTab] = useState<Tab>("organization")

  return (
    <div className="max-w-7xl mx-auto bg-white dark:bg-base-200 p-6 sm:p-8 rounded-lg shadow-sm">
      <div className="p-4">
        <div role="tablist" className="tabs tabs-border">
          <a
            role="tab"
            className={`tab ${activeTab === "organization" ? "tab-active" : ""}`}
            onClick={() => setActiveTab("organization")}
          >
            Организация
          </a>
          <a
            role="tab"
            className={`tab ${activeTab === "departments" ? "tab-active" : ""}`}
            onClick={() => setActiveTab("departments")}
          >
            Отделы
          </a>
          <a
            role="tab"
            className={`tab ${activeTab === "configurations" ? "tab-active" : ""}`}
            onClick={() => setActiveTab("configurations")}
          >
            Конфигурации
          </a>
        </div>
        <div className="p-4 bg-base-100 rounded-box mt-[-8px]">
          {activeTab === "organization" && <OrganizationTab />}
          {activeTab === "departments" && <div>Отделы</div>}
          {activeTab === "configurations" && <div>Конфигурации</div>}
        </div>
      </div>
    </div>
  )
}
